import PageHome from '../pages/home/index'
import PublishForm from '../pages/publish/pub-form'
import PublishAppraisers from '../pages/publish/pub-appraisers'
import List from '../pages/list/list'
import Detail from '../pages/detail/detail'
import View from '../pages/detail/view'
import Certificate from '../pages/detail/certificate'
import MyOrder from '../pages/my/order-list'
import MyOrderDetail from '../pages/my/order-detail'
import Appraisal from '../pages/appraiser/appraisal'
import ExpertIndex from '../pages/appraiser/index'
import ExpertOrder from '../pages/appraiser/order'
import ExpertOrderDetail from '../pages/appraiser/order-detail'
import ExpertWithdraw from '../pages/appraiser/withdraw'
import ExpertWithdrawList from '../pages/appraiser/withdraw-list'
import Page404 from '../pages/404'

const routes = [
  {
    name: 'home',
    path: '/',
    props: true,
    component: PageHome,
    meta: {
      title: '在线鉴定',
      isLogin : false
    }
  },{
    name: 'publish',
    path: '/publish',
    props: true,
    component: PublishForm,
    meta: {
      title: '发布',
      isLogin : true
    }
  },{
    name: 'publishEdit',
    path: '/publish/edit',
    props: true,
    component: PublishForm,
    meta: {
      title: '发布',
      isLogin : true
    }
  },{
    name: 'publishSelect',
    path: '/publish/appraisers',
    props: true,
    component: PublishAppraisers,
    meta: {
      title: '发布',
      isLogin : true
    }
  },{
    name: 'list',
    path: '/list',
    props: true,
    component: List,
    meta: {
      title: '专家列表',
      isLogin : false
    }
  },{
    name: 'detail',
    path: '/detail',
    props: true,
    component: Detail,
    meta: {
      title: '专家详情',
      isLogin : false
    }
  },{
    name: 'view',
    path: '/view',
    props: true,
    component: View,
    meta: {
      title: '藏品详情',
      isLogin : true
    }
  },{
    name: 'certificate',
    path: '/certificate',
    props: true,
    component: Certificate,
    meta: {
      title: '鉴定证书',
      isLogin : false
    }
  },{
    name: 'my',
    path: '/my',
    props: true,
    redirect : '/my/order',
    meta : {
      title : '我的',
      isLogin : true
    }
  },{
    name: 'myOrder',
    path: '/my/order',
    props: true,
    component: MyOrder,
    meta: {
      title: '我的订单',
      isLogin : true
    }
  },{
    name: 'orderDetail',
    path: '/my/order/detail',
    props: true,
    component: MyOrderDetail,
    meta: {
      title: '订单详情',
      isLogin : true
    }
  },{
    name: 'appraiser',
    path: '/appraiser',
    props: true,
    component: ExpertIndex,
    meta: {
      title: '我的鉴定',
      isLogin : true
    }
  },{
    name: 'appraiserOrder',
    path: '/appraiser/order',
    props: true,
    component: ExpertOrder,
    meta: {
      title: '鉴定订单',
      isLogin : true
    }
  },{
    name: 'appraiserDo',
    path: '/appraiser/appraisal',
    props: true,
    component: Appraisal,
    meta: {
      title: '开始鉴定',
      isLogin : true
    }
  },{
    name: 'appraiserDetail',
    path: '/appraiser/order/detail',
    props: true,
    component: ExpertOrderDetail,
    meta: {
      title: '订单详情',
      isLogin : true
    }
  },{
    name: 'appraiserWithdraw',
    path: '/appraiser/withdraw',
    props: true,
    component: ExpertWithdraw,
    meta: {
      title: '申请提现',
      isLogin : true
    }
  },{
    name: 'appraiserWithdrawList',
    path: '/appraiser/withdrawlist',
    props: true,
    component: ExpertWithdrawList,
    meta: {
      title: '提现明细',
      isLogin : true
    }
  },
  {
    name: '404',
    path: '*',
    component: Page404
  }
]

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '')
})

export default routes
